import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "empty", "table", "tableBody"]

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)
    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.showEmpty()
      return
    }

    this.timeout = setTimeout(() => this.fetchResults(query), 250)
  }

  async fetchResults(query) {
    const url = `/admin/users/search?q=${encodeURIComponent(query)}`
    const response = await fetch(url, {
      headers: {
        Accept: "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })

    if (!response.ok) return

    const users = await response.json()
    this.renderResults(users)
  }

  renderResults(users) {
    if (users.length === 0) {
      this.tableBodyTarget.innerHTML = ""
      this.emptyTarget.querySelector("p").textContent = "No users found."
      this.showEmpty()
      return
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content

    this.tableBodyTarget.innerHTML = users
      .map((user) => {
        const name = [user.first_name, user.last_name].filter(Boolean).join(" ")
        const displayName = name || user.email

        return `
        <tr>
          <td class="whitespace-nowrap py-3 pl-4 pr-3 sm:pl-6">
            <div class="flex items-center gap-3">
              <img src="${this.escapeHtml(user.avatar_url)}" alt="" class="h-8 w-8 rounded-full bg-app-surface-alt object-cover" />
              <div class="text-sm font-medium text-app-text">${this.escapeHtml(displayName)}</div>
            </div>
          </td>
          <td class="hidden whitespace-nowrap px-3 py-3 text-sm text-app-text-muted md:table-cell">${this.escapeHtml(user.email)}</td>
          <td class="whitespace-nowrap py-3 pl-3 pr-4 text-right text-sm sm:pr-6">
            <form method="post" action="/admin/impersonation" class="inline">
              <input type="hidden" name="authenticity_token" value="${csrfToken}" />
              <input type="hidden" name="user_id" value="${user.id}" />
              <button type="submit" class="apx-btn apx-btn--solid apx-btn--sm">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" class="apx-ico">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M15.75 6a3.75 3.75 0 1 1-7.5 0 3.75 3.75 0 0 1 7.5 0ZM4.501 20.118a7.5 7.5 0 0 1 14.998 0A17.933 17.933 0 0 1 12 21.75c-2.676 0-5.216-.584-7.499-1.632Z" />
                </svg>
                Impersonate
              </button>
            </form>
          </td>
        </tr>
      `
      })
      .join("")

    this.showTable()
  }

  showEmpty() {
    this.emptyTarget.classList.remove("hidden")
    this.tableTarget.classList.add("hidden")
  }

  showTable() {
    this.emptyTarget.classList.add("hidden")
    this.tableTarget.classList.remove("hidden")
  }

  escapeHtml(text) {
    const div = document.createElement("div")
    div.textContent = text
    return div.innerHTML
  }
}
